/* global Piwik */

export function getTracker() {
  if (typeof Piwik !== "undefined") {
    return Piwik.getAsyncTracker();
  } else {
    return null;
  }
}

/**
 * Track page view
 * @param {string}  url
 * @param {string} [title]
 */
export function trackPageView(url, title) {
  try {
    const tracker = getTracker();
    tracker && tracker.setCustomUrl(url);
    tracker && tracker.trackPageView(title);
  } catch (err) {
    console.warn(err);
  }
}

/**
 * Track link click
 * @param {string} url
 * @param {string} [linkType]
 */
export function trackLink(url, linkType) {
  try {
    const tracker = getTracker();
    tracker && tracker.trackLink(url, linkType);
  } catch (err) {
    console.warn(err);
  }
}

export function trackProductView({ material, description, categories, price, currency }) {
  try {
    const productCategories = categories ? categories.slice(0, 5).map((cat) => cat.name) : [];
    const productPrice = price && currency === "EUR" ? price : null;
    const tracker = getTracker();
    tracker && tracker.setEcommerceView(material, description, productCategories, productPrice);
  } catch (err) {
    console.warn(err);
  }
}

export function trackSiteSearch(searchTerm, category) {
  try {
    const tracker = getTracker();
    tracker && tracker.trackSiteSearch(searchTerm, category);
  } catch (err) {
    console.warn(err);
  }
}

export function isTrackerFound() {
  try {
    const tracker = getTracker();
    return tracker != null;
  } catch (err) {
    console.warn(err);
  }
}

export function isUserOptOut() {
  try {
    const tracker = getTracker();
    return Boolean(tracker && tracker.isUserOptedOut());
  } catch (err) {
    console.warn(err);
  }
}

export function toggleUserOptOut(optOut) {
  try {
    const tracker = getTracker();
    return tracker && (optOut ? tracker.optUserOut() : tracker.forgetUserOptOut());
  } catch (err) {
    console.warn(err);
  }
}
